import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Event } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-event-details-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './event-details-modal.component.html',
  styleUrl: './event-details-modal.component.scss'
})
export class EventDetailsModalComponent {
  @Input() event: Event | undefined;

  constructor(public activeModal: NgbActiveModal) {}

    closeModal(): void {
    this.activeModal.close();
  }
}
